import { CircleUser } from 'lucide-react'
import { ThemeToggle } from './ThemeToggle.tsx'

/**
 * Header for the authenticated pages: theme control + signed-in user, aligned
 * right over the content column. The brand mark lives in the sidebar, not here.
 * `name` is a placeholder until per-account auth lands (Phase 2) — Phase 0 is a
 * single shared-password gate.
 */
export function TopBar({ name = 'Admin' }: { name?: string }) {
  return (
    <header className="topbar">
      <div className="topbar__actions">
        <ThemeToggle />
        <div className="userchip">
          <span className="userchip__hi">
            Welcome, <strong>{name}</strong>!
          </span>
          <span className="avatar" aria-hidden="true">
            <CircleUser size={22} strokeWidth={1.8} />
          </span>
        </div>
      </div>
    </header>
  )
}
